<template>
  <LiteVersion v-if="showProfileVersion() === 'Lite'" />
  <Germany v-if="showProfileVersion() === 'German'" />
  <Netherland v-if="showProfileVersion() === 'Netherland'" />
</template>

<script setup>
import Germany from "@/components/User/Profile/Country/Germany.vue";
import LiteVersion from "@/components/User/Profile/Country/LiteVersion.vue";
import Netherland from "@/components/User/Profile/Country/Netherland.vue";
import { useTenantConfig } from "@/composables/useTenantConfig";
import { getProfileVersion } from "@/composables/useProfileFieldCheck";

const { tenantConfig } = useTenantConfig();
const { showProfileVersion } = getProfileVersion(tenantConfig);
</script>
